import { animated, useTransition } from '@react-spring/web';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useClickAway } from 'react-use';
import { useNavigationHeight } from "../../helper/hooks/useNavigationHeight.js";
import styles from "./Drawer.module.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Drawer({
  onClickOutside,
  anchor,
  open,
  variant,
  children,
  className
}) {
  const drawerRef = useRef(null);
  const top = useNavigationHeight();
  const topValue = `var(--navigation-height, ${variant === 'navigation' ? 0 : top}px)`;
  const transition = useTransition(open, {
    from: {
      [anchor]: -450,
      pointerEvents: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      boxShadow: '0 8px 10px -5px rgb(0 0 0 / 0%), 0px 16px 24px 2px rgb(0 0 0 / 0%), 0px 6px 30px 5px rgb(0 0 0 / 0%)'
    },
    enter: {
      [anchor]: 0,
      pointerEvents: 'auto',
      backgroundColor: 'rgba(0,0,0,0.5)',
      boxShadow: '0 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)'
    },
    leave: {
      [anchor]: -450,
      pointerEvents: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
      boxShadow: '0 8px 10px -5px rgb(0 0 0 / 0%), 0px 16px 24px 2px rgb(0 0 0 / 0%), 0px 6px 30px 5px rgb(0 0 0 / 0%)'
    }
  });
  useClickAway(drawerRef, event => {
    onClickOutside?.(event);
  });
  return /*#__PURE__*/createPortal(transition((style, item) => item ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [variant === 'navigation' && /*#__PURE__*/_jsx(animated.div, {
      style: {
        backgroundColor: style.backgroundColor,
        pointerEvents: style.pointerEvents
      },
      className: classNames(styles.drawerBackdrop, styles[variant])
    }), /*#__PURE__*/_jsx(animated.div, {
      ref: drawerRef,
      style: {
        [anchor]: style[anchor],
        boxShadow: style.boxShadow,
        top: topValue,
        height: `calc(100vh - ${topValue})`
      },
      id: "drawer",
      className: classNames(className, styles.drawer),
      children: children
    })]
  }) : null), document.body);
}